import React from "react";
import Grid_Chart from "src/components/common/gridWrapper/Grid_Chart";
import { PivotRowConfig, DEFAULT_LEADING_COLUMNS } from "src/utils/grid/gridPivotUtils";
import { MONTH_LABELS, buildMonthlySeries } from "src/utils/chart/chartUtils";
import { PRD5040_R01ResultDto } from "./Dto_PRD5040_R01";

// Table 컴포넌트가 받는 props 타입
interface Props {
	data: PRD5040_R01ResultDto[]; // 월별(1~12월) 결과 리스트
}

// 월별 양품율 피벗 그리드의 구분별 행 설정
const PIVOT_ROWS: PivotRowConfig<PRD5040_R01ResultDto>[] = [
	{ field: "productQty", label: "생산수량" },
	{ field: "badQty", label: "불량수량" },
	{ field: "yieldRate", label: "양품율" },
];

// 월별 양품율 피벗 그리드 컴포넌트 (grid_chart 공통 컴포넌트 사용)
export const Table_PRD5040_R01: React.FC<Props> = ({ data }) => {
	return (
		<Grid_Chart<PRD5040_R01ResultDto>
			data={data}
			rowData={PIVOT_ROWS}
			leadingColumnDefs={DEFAULT_LEADING_COLUMNS}
			periodLabels={MONTH_LABELS}
			seriesBuilder={buildMonthlySeries}
			columnStateKey="PRD5040_R01-chart-grid-column-state"
		/>
	);
};
